import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DoneIcon from "@mui/icons-material/Done";
import Button from "@mui/material/Button";

const plansData = [
  {
    title: "Master Java Interview Knack (MAJIK )",
    level: "LEVEL 1",
    duration: "WEEK 5 (10 HRS)",
    topics: [
      "Introduction to Java from basics",
      "Real-time case study",
      "Environment Set Up",
      "Real-time practical implementation of OOP concepts",
      "Encapsulation",
      "Inheritance - Aggregation, Composition & IS-A",
      "Data Abstraction and Layering",
      "Polymorphism",
    ],
    evaluation: "Evaluation to Join L2 (1 week time)",
  },
  {
    title: "INTERMEDIATE",
    level: "LEVEL 2",
    duration: "(20 HRS)",
    topics: [
      "Constructor and POJO Class",
      "Object Handling",
      "Understanding Cardinality Between Different Classes",
      "Understanding real-time business scenario and design and develop classes and implement the application logic",
      "Introduction to multiple object storage and data structure",
      "Interface",
      "Exception Handling",
      "Introduction to Database",
      "Establishing connection to database using Java",
      "Understanding static modifier",
      "Understanding final, finally, throw and throws",
      "Interview Hacks",
      "Case Studies",
    ],
  },
  {
    title: "ADVANCED",
    level: "LEVEL 3",
    duration: "(30 HRS)",
    topics: [
      "Collections, ArrayList, Sorting Objects",
      "Comparable and Comparator, Linked List, Vector",
      "Set, TreeSet, Map, HashMap",
      "Industry used design patterns to connect to Database (DAO design pattern)",
      "Solid Principles",
      "Most commonly used designed patterns in the industry",
      "Java 8 Features: - API Streams, Date Time API and Functional Interface",
      "Lambda Expressions",
      "Main Project with Database, Bonus",
      "Resume building session and Placement Assistance",
      "Discussion on current interview questions",
      "Overview of Spring and Spring Boot",
      "Overview of HTML, CSS and JS",
    ],
  },
];

const PriceCard = () => {
  return (
    <Box sx={{ width: "100%", my: 10 }}>
      <Box sx={{ px: 6 }}>
        <Typography
          marginBottom="100px"
          fontFamily="inter"
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: { xs: 24, md: 40 },
          }}
        >
          Master Java Interview Knack (MAJIK )
        </Typography>
      </Box>

      <Grid
        container
        rowSpacing={1}
        sx={{ px: 6, mt: 4 }}
        xs={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {plansData.map((plan, index) => (
          <Grid
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            key={index}
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              minHeightheight: "740px",
              width: "33%",

              ...(index % 2 === 1 && { backgroundColor: "#F8F8F8" }),
            }}
          >
            <Box>
              <Box sx={{ px: 4, pt: 4 }}>
                <Typography
                  fontFamily="inter"
                  variant="body2"
                  gutterBottom
                  sx={{
                    fontWeight: "600",
                    mt: 1,
                  }}
                >
                  {plan.title}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    gap: 1,
                  }}
                >
                  <Typography
                    fontFamily="inter"
                    variant="body2"
                    gutterBottom
                    sx={{
                      fontWeight: "600",
                      mt: 1,
                      fontSize: "20px",
                    }}
                  >
                    {plan.level}
                  </Typography>
                  <Typography
                    fontFamily="inter"
                    variant="body2"
                    gutterBottom
                    sx={{
                      fontWeight: "600",
                      mt: 1,
                      fontSize: "15px",
                      color: "#898989",
                    }}
                  >
                    {plan.duration}
                  </Typography>
                </Box>

                {plan.topics.map((topic, idx) => (
                  <Typography
                    key={idx}
                    fontFamily="inter"
                    variant="body2"
                    gutterBottom
                    sx={{
                      mt: idx === 0 ? 2 : 1,
                      lineHeight: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      fontWeight: "medium",
                      fontSize: "13px",
                    }}
                  >
                    <DoneIcon
                      sx={{
                        fontSize: 20,
                        color: "#12B005",
                        fontWeight: "bold",
                      }}
                    />
                    {topic}
                  </Typography>
                ))}

                {plan.evaluation && (
                  <Typography
                    fontFamily="inter"
                    variant="body2"
                    gutterBottom
                    sx={{
                      mt: 2,
                      lineHeight: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      fontWeight: "medium",
                      textTransform: "uppercase",
                      fontSize: "13px",
                    }}
                  >
                    {plan.evaluation}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                m: 4,
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  width: "100%",
                  height: "45px",
                  textTransform: "none",
                  py: 1,
                  borderRadius: "4px",
                  fontSize: "12px",
                  "&:hover": {
                    backgroundColor: " #ffe000 !important",
                    color: "black",
                  },
                }}
                style={{
                  fontWeight: "600",
                  backgroundColor: "#FFFFFF",
                  borderColor: "#A5A5A5",
                  color: "black",
                }}
              >
                Choose Plan
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PriceCard;
